import { EMAIL_MESSAGE, NO_RESERVED_EMAIL_MESSAGE, REQUIRED_MESSAGE } from '@Const/error-messages'
import { stringSizeMaxMessage } from '@Entities/schemas/work/error-messages'
import { isNotAnReservedEmailBoolean } from '@App/helpers/validate'
import { z } from 'zod'

const email = z
    .string()
    .min(1, REQUIRED_MESSAGE)
    .trim()
    .toLowerCase()
    .email(EMAIL_MESSAGE)
    .max(2000, stringSizeMaxMessage('Email', 2000))
    .refine(isNotAnReservedEmailBoolean, NO_RESERVED_EMAIL_MESSAGE)

export { email }
